import React from 'react';
import classnames from 'classnames';
import { BubbleProps } from 'tea-component';
import NP_PERMISSION from '@gp/assets/svg/no-permission.svg';
import SvgIcon from '@home/components/SvgIcon';
import classNames from 'classnames';
import './index.scss';
interface RestrictedContentProps extends BubbleProps {
  className?: string;
}

// 宽表ExpandAll操作单元格
const TabExpandAll: React.FC<RestrictedContentProps> = (props) => {
  const { handleExpandAll, data, totalNum = 10 } = props;
  const { isExpand = false } = data || {};

  return (
    <div className="dbg-change-log-detail-table-expand-content">
      <div className="dbg-time-change-icon-wrapper">
        <SvgIcon className="dbg-time-change-icon" type="updating" />
      </div>
      <div className="dbg-change-log-detail-table-expand-content-text">
        <span className="dbg-change-log-detail-table-expand-content-text-label">
          {!isExpand ? (
            <>
              <span className="dbg-change-log-detail-table-expand-content-text-label-total">
                {`Total: ${totalNum} change logs. Each tab displays the most recent change log. `}
              </span>
              <span
                className="dbg-change-log-detail-table-expand-content-text-label-tips"
                onClick={() => {
                  handleExpandAll(isExpand, data);
                }}
              >
                {'Click here to expand all'}
              </span>
            </>
          ) : (
            <>
              <span className="dbg-change-log-detail-table-expand-content-text-label-total">
                {`Total: ${totalNum} change logs. `}
              </span>
              <span
                className="dbg-change-log-detail-table-expand-content-text-label-tips"
                onClick={() => {
                  handleExpandAll(isExpand, data);
                }}
              >
                {'Click here to fold all'}
              </span>
            </>
          )}
        </span>
      </div>
      <div>
        <SvgIcon
          className={classNames('dbg-milestone-card-icon', {
            'dbg-milestone-card-icon-active': isExpand,
          })}
          type="fill-icon-arrow"
          onClick={() => {
            handleExpandAll(isExpand, data);
          }}
        />
      </div>
    </div>
  );
};

export default TabExpandAll;

// className="dbg-milestone-card-icon dbg-milestone-card-icon-active"
